export { default } from './TooltipedSortLabelCDS';
